const { Tab } = require('@mui/material');
const { styled } = require('@mui/system');

const StyledPageTab = styled(Tab)({
    paddingLeft: 40,
    paddingRight: 40
});

export default StyledPageTab;
